import RadioCardListPage from "@components/RadioCardListPage"

const OPTIONS = [
  { emoji: "🤩", key: "wantOneToo" },
  { emoji: "💬", key: "cantStopComplimenting" },
  { emoji: "😲", key: "surprisedRealistic" },
  { emoji: "🥹", key: "capturesPerfectly" },
]

export default function PetsFutureOutcomePage() {
  return (
    <RadioCardListPage translationKey="petsFutureOutcome" options={OPTIONS} />
  )
}
